<template>
  <div>
    <Hero/>
    <Features/>
    <AwardsCalls/>
    <background-wrapper>
      <div class="text-center how-we-can-help">
        <div class="how-we-can-help__title">
          <h2 class="h2 d-inline-block mr-0 mr-md-1 mb-0">{{$t(`products.${$route.name}.how-we-can-help-with.title`)}}</h2>
          <b-navbar-nav class="d-inline-flex">
            <b-nav-item-dropdown :text="$t(`products.${$route.name}.how-we-can-help-with.options.${activeSlide}`)" right class="h2 mb-0">
              <b-dropdown-item v-for="n in 6" :key="n" :active="n === activeSlide" @click="changeSlide(n)" class="text-dark" href="#">{{$t(`products.${$route.name}.how-we-can-help-with.options.${n}`)}}</b-dropdown-item>
            </b-nav-item-dropdown>
          </b-navbar-nav>
        </div>
      </div>
      <template v-slot:background>
        <VueSlickCarousel ref="slider" class="how-we-can-help__slider" :fade="true">
          <div v-for="n in 6" :key="n">
            <div class="slide-image">
              <img :src="require(`@/assets/live-hr-advice/slider/slide_${n}_${$i18n.locale}.png`)">
            </div>
          </div>
        </VueSlickCarousel>
      </template>
    </background-wrapper>
    <ContentWithImage class="need-us" sectionName="need-us" text-size="sm" justify-center image-order="0" image-order-sm="0" img-width="80%" h2/>
    <background-wrapper :src="routeNameKebab + '/fullscreen-image_success'" ext="png">
      <text-container class="success" size="lg" align-center justify-center>
        <h2 class="h1" v-html="$t(`products.${$route.name}.success.title`)"/>
        <p v-html="$t(`products.${$route.name}.success.text`)"/>
        <b-btn class="mt-2" variant="primary" v-scroll-to="{ el: '#request-a-demo', offset: -70 }">
          {{$t(`request-demo`)}}
        </b-btn>
      </text-container>
    </background-wrapper>
    <RequestDemo/>
    <Tools/>
    <LetsGet/>
  </div>
</template>

<script>
import { Hero, Tools, LetsGet, Features, ContentWithImage, RequestDemo, AwardsCalls } from '@/components/ui/products'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'

export default {
  name: 'LiveHrAdvice',
  components: { Hero, Tools, LetsGet, Features, ContentWithImage, RequestDemo, VueSlickCarousel, AwardsCalls },
  computed: {
    routeNameKebab: app => app.$toKebabCase(app.$route.name)
  },
  data () {
    return {
      activeSlide: 1
    }
  },
  methods: {
    changeSlide (n) {
      this.$refs.slider.goTo(n - 1)
      this.activeSlide = n
    }
  }
}
</script>

<style lang="sass">
.need-us
  img
    width: 400px!important

.how-we-can-help__title
  +media-breakpoint-down(xxs)
    .dropdown-toggle
      white-space: normal
</style>

<style lang="sass" scoped>
.success
  padding-top: 200px
  padding-bottom: 300px
  +media-breakpoint-down(sm)
    padding-top: 60px
    padding-bottom: 300px

.how-we-can-help
  height: calc(100vw * 0.53013278856)
  +media-breakpoint-down(lg)
    height: calc(140vw * 0.53013278856)
  +media-breakpoint-down(md)
    height: calc(180vw * 0.53013278856 + 50px)
  +media-breakpoint-down(sm)
    height: calc(180vw * 0.53013278856 + 100px)
  +media-breakpoint-down(xxs)
    height: calc(180vw * 0.53013278856 + 150px)

  &__slider
    overflow-x: none
    margin-top: auto

  &__title
    display: flex
    align-items: center
    justify-content: center
    padding-top: 80px
    +media-breakpoint-down(lg)
      padding-top: 60px
    +media-breakpoint-down(md)
      flex-direction: column
      padding-top: 50px
    +media-breakpoint-down(sm)
      .h2
        font-size: 28px
    +media-breakpoint-down(xxs)
      .dropdown-toggle
        white-space: wrap

.slide-image
  +media-breakpoint-down(lg)
    margin: 0 -20vw
  +media-breakpoint-down(md)
    margin: 0 -40vw

  img
    max-width: 100%
</style>



// WEBPACK FOOTER //
// src/components/products/LiveHrAdvice/LiveHrAdvice.vue